<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="parentId" label="父编号" sortable width="100">
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="名称"
        sortable
        width="180"
      >
      </el-table-column>
      <el-table-column
          align="center"
          prop="enName"
          label="英文名称"
          sortable
          width="180"
      >
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="90">
        <template slot-scope="scope">
          {{ getValue(CATEGORY_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="icon" label="图标" width="100">
        <template slot-scope="scope">
          <el-image
            :src="getTableThumbnailImg(scope.row.icon, 50)"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sortNo"
        label="排序号"
        width="100"
      ></el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="checkDialogFormVisible(true, scope.row, 'CREATE')"
            >创建子菜单</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="类目名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="类目英文名称" prop="enName">
          <el-input v-model="form.enName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
            v-model="form.status"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in CATEGORY_STATUS"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.CATEGORY"
            @valueFunc="getImgsValueFunc"
            paramsType="iconLogo"
            :model="form.icon"
            :maxCount="1"
          />
        </el-form-item>
        <el-form-item label="排序号" prop="sortNo">
          <el-input
            v-model="form.sortNo"
            placeholder="请输入排序号，值越大越靠前"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCategoryTree, editCategory } from "@/api/category";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  CATEGORY_STATUS,
  UPLOAD_IMG_TYPE
} from "@/utils/enumUtile";
import {
  formatApiDate,
  getFileName,
  getTableThumbnailImg
} from "@/utils/utils";
import UploadList from "@/views/components/uploadList.vue";

export default {
  computed: {
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    CATEGORY_STATUS() {
      return CATEGORY_STATUS;
    },
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    }
  },
  components: { UploadList },
  filters: {},
  data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {},
      dialogFormVisible: false, // 新增 or 编辑的弹框
      dialogType: "",
      rules: {
        name: [
          { required: true, message: "菜单名称不能为空", trigger: "change" }
        ],
        enName: [
          { required: true, message: "菜单英文名称不能为空", trigger: "change" }
        ],
        status: [{ required: true, message: "状态不能为空", trigger: "change" }]
      },
      form: {
        id: 0,
        parentId: 0,
        name: null,
        enName: null,
        status: null,
        icon: [],
        sortNo: null
      },
      btnLoading: false
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getTableThumbnailImg,
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      getCategoryTree(this.listQuery)
        .then(response => {
          this.list = response.data || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (type === "CREATE") {
        if (editObj && Object.keys(editObj).length !== 0) {
          this.form.parentId = editObj.id;
        } else {
          this.form.parentId = 0;
        }
      }
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.status = editObj.status;
        this.form.name = editObj.name;
        this.form.enName = editObj.enName;
        // this.form.icon = editObj.icon;
        this.form.parentId = editObj.parentId;
        this.form.sortNo = editObj.sortNo;
        if (editObj.icon) {
          const attDataArr = [];
          attDataArr.push({
            url: editObj.icon,
            dbUrl: editObj.icon,
            name: getFileName(editObj.icon)
          });
          this.form.icon = attDataArr;
        }
      }
      if (!status) {
        this.form.id = 0;
        this.form.status = null;
        this.form.name = null;
        this.form.enName = null;
        this.form.icon = [];
        this.form.parentId = null;
        this.form.sortNo = null;
        this.$refs.form.resetFields();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            status: form.status,
            parentId: form.parentId,
            name: form.name,
            enName: form.enName,
            sortNo: form.sortNo
          };
          if (form.icon && form.icon.length !== 0) {
            const urlArr = form.icon.map(obj => obj["dbUrl"]);
            params.icon = urlArr.join(",");
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editCategory(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "iconLogo") {
        this.form.icon = value;
      }
    },

  }
};
</script>

<style scoped lang="scss"></style>
